/**
 * 沿革ページの年リストナビゲーション制御
 * Lenis.js対応版
 */

export const followMenu = () => {
  const navigationItems = document.querySelectorAll('.js-year-link');

  if(!navigationItems.length) return;

  const navigationWrapper = document.querySelector('.follow-list-navigation');
  const contentItems = document.querySelectorAll('.follow-list-content-item');
  let lastScrollTime = Date.now();
  const throttleInterval = 50; // スクロールイベントの間隔（ミリ秒）

  // 現在の年のナビゲーションアイテムを左端に表示する
  function scrollCurrentYearIntoView(currentLink) {
      if (!currentLink || window.innerWidth >= 768) return;

      const linkLeft = currentLink.offsetLeft;
      const padding = 0;
      const targetScroll = linkLeft - padding;

      navigationWrapper.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
      });
  }

  function updateCurrentYear() {
      const now = Date.now();
      if (now - lastScrollTime < throttleInterval) return;
      lastScrollTime = now;

      const scrollTop = window.lenis?.scroll || window.scrollY;
      const headerHeight = document.querySelector('header')?.offsetHeight || 0;
      const threshold = headerHeight + 10;

      let currentYear = null;
      let currentLink = null;

      // 各コンテンツアイテムの位置をチェック
      contentItems.forEach(item => {
          const rect = item.getBoundingClientRect();
          const absoluteTop = rect.top + scrollTop;
          
          if (absoluteTop <= scrollTop + threshold) {
              currentYear = item.dataset.year;
          }
      });

      if (!currentYear && contentItems.length > 0) {
          currentYear = contentItems[0].dataset.year;
      }

      // ナビゲーションアイテムの状態を更新
      navigationItems.forEach(link => {
          const year = link.getAttribute('href').replace('#history-', '');
          if (year === currentYear) {
              link.classList.add('current');
              currentLink = link;
          } else {
              link.classList.remove('current');
          }
      });

      // 現在の年を表示位置に自動スクロール
      scrollCurrentYearIntoView(currentLink);
  }


  function displayNavigation(bool=true) {
    if(bool) {
      navigationWrapper.classList.remove('is-fadeOut');
    } else {
      navigationWrapper.classList.add('is-fadeOut');
    }
  }

  const targetElement = document.querySelector('.footer');
  if (targetElement) {
      const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  // 要素が画面に入ったらナビゲーションを非表示
                  displayNavigation(false);
              } else {
                  // 要素が画面から出たらナビゲーションを表示
                  displayNavigation(true);
              }
          });
      }, {
          threshold: 0.1// 10%見えたら反応
      });

      observer.observe(targetElement);
  }

  // Lenisのスクロールイベントにリスナーを追加
  if (window.lenis) {
      window.lenis.on('scroll', updateCurrentYear);
  } else {
      window.addEventListener('scroll', updateCurrentYear);
  }

  // 初期表示時の実行
  updateCurrentYear();

}